import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { matchPath, Navigate } from "react-router-dom";

const customerRecordBreadcrumb = breadcrumbSlot();

const HIDE_PADDING_ROUTES: string[] = ["/all-customers", "/:customerId"];

function hidePadding(url: string): boolean {
  return HIDE_PADDING_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/customer${route}`, url),
  );
}

const FULLSCREEN_ROUTES: string[] = [];

const HIDE_HEADER_ROUTES: string[] = [...FULLSCREEN_ROUTES];
function hideHeader(url: string): boolean {
  return HIDE_HEADER_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/customer${route}`, url),
  );
}

const HIDE_NAV_ROUTES: string[] = [...FULLSCREEN_ROUTES];

function hideNav(url: string): boolean {
  return HIDE_NAV_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/customer${route}`, url),
  );
}

export const customersRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Customers" },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={hideHeader}
            hideNavbar={hideNav}
            hidePadding={hidePadding}
          />
        ),
      };
    },
    children: [
      { index: true, element: <Navigate replace to="all-customers" /> },
      {
        path: "all-customers",
        handle: { breadcrumb: "All Customers" },
        async lazy() {
          const { CustomersPage } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-merchant-customer-app/customers-page");
          return { Component: CustomersPage };
        },
      },
      {
        handle: { breadcrumb: customerRecordBreadcrumb },
        path: ":customerId",
        async lazy() {
          const { CustomerRecord } =
            await import("@redotech/redo-merchant-customer-app/customer-record/customer-record-page");
          return {
            element: <CustomerRecord breadcrumb={customerRecordBreadcrumb} />,
          };
        },
      },
    ],
  },
];
